module.exports = __webpack_public_path__ + "static/WEDDING E&M-308-baa686d8301d540df67d808b97c52279.jpg";